import { Flex, Text } from "@chakra-ui/react";
import StatusBadge from "components/badge/StatusBadge";
import { formatTime } from "constants/commonFunctions";
import { formatDateToDDMONTHNAMEYYYY } from "utils/common";

export const recommendationColumns = [
  {
    Header: "OWNER",
    accessor: "owner_data",
    Cell: ({ value }) => (
      <a
        _hover={{ textDecoration: "underline" }}
        href={`/#/admin/users?search_text=${value?.phone}`}
        target="_blank"
        rel="noreferrer"
        cursor="pointer"
        whiteSpace={"nowrap"}
        style={{ fontSize: "11px", fontWeight: 600, textAlign: "left" }}
      >
        {value?.phone
          ? `${value.first_name} ${value.last_name} (${value.phone})`
          : "-"}
      </a>
    ),
  },
  {
    Header: "SLUG",
    accessor: "ad_data",
    Cell: ({ value }) => (
      <a
        _hover={{ textDecoration: "underline" }}
        href={`${process.env.REACT_APP_HEXAHOME_BASE_URL}/property-details/${value?.slug_url}`}
        target="_blank"
        rel="noreferrer"
        cursor="pointer"
        whiteSpace={"nowrap"}
        style={{ fontSize: "11px", fontWeight: 600, textAlign: "left" }}
      >
        {value?.slug_url || "-"}
      </a>
    ),
  },
  {
    Header: "USER",
    accessor: "user_data",
    Cell: ({ value }) => (
      <a
        _hover={{ textDecoration: "underline" }}
        href={`/#/admin/users?search_text=${value?.phone}`}
        target="_blank"
        rel="noreferrer"
        cursor="pointer"
        whiteSpace={"nowrap"}
        style={{ fontSize: "11px", fontWeight: 600, textAlign: "left" }}
      >
        {value?.phone
          ? `${value.first_name} ${value.last_name} (${value.phone})`
          : "-"}
      </a>
    ),
  },

  {
    Header: "SENT BY",
    accessor: "created_by",
    Cell: ({ value }) => (
      <Flex align="center" justify={"center"}>
        <Text>
          <StatusBadge status={value} />
        </Text>
      </Flex>
    ),
  },

  {
    Header: "LOCATION",
    accessor: "ad_data.location",
    Cell: ({ value }) => (
      <Text
        cursor="pointer"
        whiteSpace={"nowrap"}
        style={{ fontSize: "11px", fontWeight: 600, textAlign: "left" }}
      >
        {value?.locality}, {value?.city}
      </Text>
    ),
  },
  {
    Header: "SENT ON",
    accessor: "created_at",
    Cell: ({ value }) => (
      <Text>
        {formatDateToDDMONTHNAMEYYYY(value)} {formatTime(value)}
      </Text>
    ),
  },
];
